module.exports = __webpack_public_path__ + "static/media/40-8.9af4881d.mp3";